import { render, staticRenderFns } from "./SamplesModelDialog.vue?vue&type=template&id=712b9846&scoped=true"
import script from "./SamplesModelDialog.vue?vue&type=script&lang=ts"
export * from "./SamplesModelDialog.vue?vue&type=script&lang=ts"
import style0 from "./SamplesModelDialog.vue?vue&type=style&index=0&id=712b9846&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b9846",
  null
  
)

export default component.exports